import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import map from 'lodash/map';

const sizes = {
  sm: '.85rem',
  md: '.95rem',
  lg: '1.05rem',
};

const FontSizeOption = ({
  onClick = () => {},
}) => {
  const htmlTag = document.documentElement;
  const [size, setSize] = useState(
    Cookies.get('competition.font.size') || 'md',
  );

  useEffect(() => {
    htmlTag.style.fontSize = sizes[size];
    Cookies.set('competition.font.size', size, {
      expires: 365,
      sameSite: 'strict',
      secure: window.location.protocol === 'https:',
    });
  }, [size]);

  return (
    <span className="btn btn-sm btn-link">
      {map(sizes, (s, i) => (
        <span
          key={i}
          className="cursor-pointer ml-1"
          style={{ fontSize: s }}
          onClick={() => {
            setSize(i);
            onClick(i);
          }}
        >
          {i === size ? <u>A</u> : 'A'}
        </span>
      ))}
    </span>
  );
};

export default FontSizeOption;
